import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import VocabMaster from "./VocabMaster";

const VALID_USERNAME = process.env.REACT_APP_LOGIN_USERNAME || "upsc";
const VALID_PASSWORD = process.env.REACT_APP_LOGIN_PASSWORD || "StudySuccess2028";

const PHASES = [
  {id:"p1",name:"Foundation",subname:"NCERT Mastery (3-4m)",icon:"⚡",color:"#FF6B6B",gradient:"linear-gradient(135deg, #FF6B6B 0%, #FFA07A 100%)",tasks:8},
  {id:"p2",name:"Core Mastery",subname:"GS Deep Dive (5-6m)",icon:"📚",color:"#4ECDC4",gradient:"linear-gradient(135deg, #4ECDC4 0%, #44A5C2 100%)",tasks:12},
  {id:"p3",name:"Prelims Spec.",subname:"CSAT + Mocks (4-5m)",icon:"🎯",color:"#FFD93D",gradient:"linear-gradient(135deg, #FFD93D 0%, #FFC93C 100%)",tasks:15},
  {id:"p4",name:"Mains Writing",subname:"150+ Answers (5-6m)",icon:"✍️",color:"#A8E6CF",gradient:"linear-gradient(135deg, #A8E6CF 0%, #56AB91 100%)",tasks:16},
  {id:"p5",name:"Optional",subname:"PS&IR Master (3-4m)",icon:"📖",color:"#B19CD9",gradient:"linear-gradient(135deg, #B19CD9 0%, #9370DB 100%)",tasks:10},
  {id:"p6",name:"Sprint",subname:"Final Push (1m)",icon:"🔥",color:"#FF6B9D",gradient:"linear-gradient(135deg, #FF6B9D 0%, #C44569 100%)",tasks:16},
  {id:"p7",name:"Polish",subname:"Time Management (2-3w)",icon:"✨",color:"#63E1FF",gradient:"linear-gradient(135deg, #63E1FF 0%, #0A918E 100%)",tasks:16},
  {id:"p8",name:"Interview",subname:"Final Round (3-4m)",icon:"🎤",color:"#8E9DFF",gradient:"linear-gradient(135deg, #8E9DFF 0%, #5873D9 100%)",tasks:12},
];

const DAILY_SCHEDULE = [
  {id:"s1",title:"CURRENT AFFAIRS",category:"current_affairs",color:"#FF6B6B",icon:"📰",time:"6:00 AM"},
  {id:"s2",title:"MEDITATION",category:"discipline",color:"#56AB91",icon:"🧘",time:"6:30 AM"},
  {id:"s3",title:"NCERT READING",category:"upsc",color:"#FFD93D",icon:"📖",time:"7:00 AM"},
  {id:"s4",title:"VOCABULARY",category:"english",color:"#B19CD9",icon:"📚",time:"9:00 AM"},
  {id:"s5",title:"MCQ PRACTICE",category:"upsc",color:"#FFD93D",icon:"❓",time:"10:00 AM"},
  {id:"s6",title:"SCHEMES DEEP DIVE",category:"current_affairs",color:"#FF6B6B",icon:"📋",time:"11:30 AM"},
  {id:"s7",title:"LUNCH + REST",category:"break",color:"#888",icon:"🍽️",time:"1:00 PM"},
  {id:"s8",title:"ANSWER WRITING",category:"upsc",color:"#FFD93D",icon:"✏️",time:"2:30 PM"},
  {id:"s9",title:"CURRENT AFFAIRS REV",category:"current_affairs",color:"#FF6B6B",icon:"🔄",time:"4:00 PM"},
  {id:"s10",title:"STANDARD BOOKS",category:"upsc",color:"#FFD93D",icon:"📕",time:"5:00 PM"},
  {id:"s11",title:"ENGLISH LISTENING",category:"english",color:"#B19CD9",icon:"🎧",time:"6:00 PM"},
  {id:"s12",title:"OPTIONAL SUBJECT",category:"upsc",color:"#FFD93D",icon:"🎓",time:"7:00 PM"},
  {id:"s13",title:"QUIZ PRACTICE",category:"upsc",color:"#FFD93D",icon:"🧠",time:"8:00 PM"},
  {id:"s14",title:"NEWS REVIEW",category:"english",color:"#B19CD9",icon:"📺",time:"8:30 PM"},
  {id:"s15",title:"INTERNATIONAL NEWS",category:"current_affairs",color:"#FF6B6B",icon:"🌍",time:"9:00 PM"},
  {id:"s16",title:"TOMORROW PLANNING",category:"discipline",color:"#56AB91",icon:"📝",time:"10:00 PM"},
];

const MOTIVATIONAL_QUOTES = [
  "The only difference between who you are and who you want to be is what you do. - Bill Phillips",
  "Success is not final, failure is not fatal. It is the courage to continue that counts. - Winston Churchill",
  "Your limitation—it's only your imagination. Push beyond it.",
  "The pain of discipline weighs ounces while the pain of regret weighs tons.",
  "Great things never came from comfort zones.",
  "Discipline is choosing between what you want now vs what you want most.",
  "Every morning you have two choices: go back to bed or wake up and chase your dreams. – Mark Twain",
  "Success doesn't just happen. You have to make it happen.",
  "IAS is not a destination. It's a journey of self-discovery.",
  "Winners are not people who never fail, but people who never quit.",
];

function getTodayKey() { return new Date().toISOString().slice(0,10); }
function getDayNumber(startDate) { if (!startDate) return 1; const diff = Math.floor((new Date() - new Date(startDate)) / (1000*60*60*24)); return Math.max(1, diff+1); }
function calcDaysRemaining() { const target = new Date(2027, 4, 1); const now = new Date(); const diff = Math.ceil((target - now)/(1000*60*60*24)); return Math.max(0, diff); }
function calcCompletionRate(tasks) { if(!tasks || Object.keys(tasks).length===0) return 0; const completed = Object.values(tasks).filter(t=>t?.done).length; return Math.round((completed/Object.keys(tasks).length)*100); }
function getRandomQuote() { return MOTIVATIONAL_QUOTES[Math.floor(Math.random()*MOTIVATIONAL_QUOTES.length)]; }

async function dbGetSchedule(date) { const {data} = await supabase.from('daily_schedule').select('tasks').eq('date',date).single(); return data?.tasks || {}; }
async function dbUpsertSchedule(date, tasks) { await supabase.from('daily_schedule').upsert({date,tasks,updated_at:new Date().toISOString()},{onConflict:'date'}); }
async function dbGetStats() { const {data} = await supabase.from('global_stats').select('stat_key,stat_value'); if (!data) return {}; return Object.fromEntries(data.map(r=>[r.stat_key,r.stat_value])); }
async function dbGetStudyLog() { const {data} = await supabase.from('study_log').select('*').order('created_at',{ascending:false}); return data||[]; }
async function dbAddStudyLog(log) { const {data} = await supabase.from('study_log').insert([{date:getTodayKey(),subject:log.subject,topic:log.topic,duration:parseInt(log.duration)||0,mcq_attempted:parseInt(log.mcqA)||0,mcq_correct:parseInt(log.mcqC)||0,notes:log.notes}]).select().single(); return data; }
async function dbGetNotes() { const {data} = await supabase.from('notes').select('*').order('created_at',{ascending:false}); return data||[]; }
async function dbAddNote(note) { const {data} = await supabase.from('notes').insert([{date:getTodayKey(),title:note.title,subject:note.subject,content:note.content,color:note.color,tags:note.tags}]).select().single(); return data; }
async function dbDeleteNote(id) { await supabase.from('notes').delete().eq('id',id); }
async function dbGetFlashcards() { const {data} = await supabase.from('flashcards').select('*').order('created_at',{ascending:false}); return data||[]; }
async function dbAddFlashcard(card) { const {data} = await supabase.from('flashcards').insert([{date:getTodayKey(),front:card.front,back:card.back,subject:card.subject,color:card.color,reviewed:false}]).select().single(); return data; }
async function dbUpdateFlashcard(id, reviewed) { await supabase.from('flashcards').update({reviewed,updated_at:new Date().toISOString()}).eq('id',id); }
async function dbDeleteFlashcard(id) { await supabase.from('flashcards').delete().eq('id',id); }
async function dbGetMockTests() { const {data} = await supabase.from('mock_tests').select('*').order('created_at',{ascending:false}); return (data||[]).map(t=>({...t,testType:t.test_type,testName:t.test_name,maxScore:t.max_score})); }
async function dbAddMockTest(t) { const {data} = await supabase.from('mock_tests').insert([{date:getTodayKey(),test_type:t.testType,test_name:t.testName,score:parseFloat(t.score)||0,max_score:parseFloat(t.maxScore)||null}]).select().single(); return data; }
async function dbGetDailyHistory() { const {data} = await supabase.from('daily_schedule').select('date,tasks').order('date',{ascending:false}).limit(365); return data||[]; }
async function dbGetStartDate() { const {data} = await supabase.from('conquest_state').select('data').eq('state_key','main').single(); return data?.data?.startDate||null; }
async function dbSetStartDate(date) { await supabase.from('conquest_state').upsert({state_key:'main',data:{startDate:date},updated_at:new Date().toISOString()},{onConflict:'state_key'}); }

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=IBM+Plex+Mono:wght@400;600;700;800&display=swap');

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}

:root {
  --dark-bg: #0F1419;
  --dark-surface: #1A1F2E;
  --dark-card: #252C3D;
  --dark-text: #F5F5FC;
  --dark-muted: #A8AEC7;
  --light-bg: #F8FAFF;
  --light-surface: #FFFFFF;
  --light-card: #FFFFFF;
  --light-text: #0F1419;
  --light-muted: #6B7280;
  --accent: #FF6B6B;
  --success: #56AB91;
  --warning: #FFD93D;
  --primary-gradient: linear-gradient(135deg, #FF6B6B 0%, #FF8787 50%, #FFB6B9 100%);
  --phase1: #FF6B6B; --phase2: #4ECDC4; --phase3: #FFD93D; --phase4: #A8E6CF;
  --phase5: #B19CD9; --phase6: #FF6B9D; --phase7: #63E1FF; --phase8: #8E9DFF;
  --radius: 14px;
  --radius-sm: 10px;
  --shadow: 0 2px 12px rgba(0,0,0,0.08);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.12);
}

body.light-mode {
  --bg: var(--light-bg); --surface: var(--light-surface); --card: var(--light-card);
  --text: var(--light-text); --muted: var(--light-muted);
  --border: #E5E7EB; --border2: #D1D5DB;
  --shadow: 0 2px 12px rgba(0,0,0,0.06);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.08);
}
body.dark-mode {
  --bg: var(--dark-bg); --surface: var(--dark-surface); --card: var(--dark-card);
  --text: var(--dark-text); --muted: var(--dark-muted);
  --border: #2D3548; --border2: #3D4663;
}

html,body{height:100%;background:var(--bg);color:var(--text);font-family:'Inter',sans-serif;font-size:14px;line-height:1.6;transition:background 0.3s,color 0.3s;-webkit-font-smoothing:antialiased;}

/* ===== LAYOUT ===== */
.app{display:flex;height:100vh;height:100dvh;overflow:hidden;}

/* SIDEBAR - desktop */
.sidebar{width:240px;min-width:240px;background:var(--surface);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow-y:auto;z-index:50;transition:all 0.3s;}
.sidebar-logo{padding:20px 16px;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center;}
.sidebar-logo h1{font-family:'IBM Plex Mono',monospace;font-size:15px;font-weight:800;letter-spacing:2px;color:var(--accent);text-transform:uppercase;}
.sidebar-logo .sub{font-size:9px;color:var(--muted);letter-spacing:1.5px;margin-top:2px;text-transform:uppercase;}
.theme-toggle{background:var(--card);border:1px solid var(--border);cursor:pointer;font-size:16px;padding:6px 10px;border-radius:var(--radius-sm);color:var(--text);transition:all 0.2s;}
.theme-toggle:hover{border-color:var(--accent);}
.nav-section{padding:8px 0;flex:1;}
.nav-label{font-size:9px;letter-spacing:1.5px;color:var(--muted);padding:10px 16px 4px;text-transform:uppercase;font-weight:600;}
.nav-item{display:flex;align-items:center;gap:10px;padding:10px 16px;cursor:pointer;font-size:13px;color:var(--muted);transition:all 0.2s;border-left:3px solid transparent;font-weight:500;}
.nav-item:hover{background:var(--card);color:var(--text);}
.nav-item.active{background:rgba(255,107,107,0.08);color:var(--accent);border-left-color:var(--accent);font-weight:600;}
.nav-item .icon{font-size:16px;width:20px;text-align:center;}
.sidebar-stat{padding:14px;background:var(--card);border-radius:var(--radius);margin:8px 12px 0;text-align:center;border:1px solid var(--border);}
.sidebar-stat .label{font-size:9px;color:var(--muted);text-transform:uppercase;letter-spacing:1px;margin-bottom:2px;font-weight:600;}
.sidebar-stat .val{font-size:18px;font-weight:800;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.sidebar-bottom{padding:12px;margin-top:auto;border-top:1px solid var(--border);}
.logout-btn{width:100%;background:transparent;color:var(--muted);border:1.5px solid var(--border);border-radius:var(--radius-sm);padding:10px;font-size:12px;cursor:pointer;transition:all 0.2s;font-weight:600;font-family:'Inter',sans-serif;}
.logout-btn:hover{color:var(--accent);border-color:var(--accent);}

/* MOBILE BOTTOM NAV */
.mobile-topbar{display:none;}
.bottom-nav{display:none;}

/* MAIN */
.main-area{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0;}
.topbar{background:var(--surface);border-bottom:1px solid var(--border);padding:0 20px;height:56px;display:flex;align-items:center;gap:8px;flex-shrink:0;overflow-x:auto;-webkit-overflow-scrolling:touch;}
.topbar::-webkit-scrollbar{display:none;}
.topbar-pill{display:flex;align-items:center;gap:6px;background:var(--card);border:1px solid var(--border);border-radius:20px;padding:6px 12px;font-size:11px;flex-shrink:0;white-space:nowrap;}
.topbar-pill .lbl{color:var(--muted);font-weight:500;}
.topbar-pill .val{color:var(--text);font-weight:700;}

.page-scroll{flex:1;overflow-y:auto;background:var(--bg);-webkit-overflow-scrolling:touch;}
.page{padding:24px;max-width:1200px;margin:0 auto;width:100%;}
.page-title{font-family:'IBM Plex Mono',monospace;font-size:22px;font-weight:800;letter-spacing:1px;margin-bottom:4px;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.page-sub{color:var(--muted);font-size:13px;margin-bottom:24px;font-weight:400;}

/* GRIDS */
.grid-auto{display:grid;grid-template-columns:repeat(auto-fill, minmax(260px, 1fr));gap:14px;}
.grid-2{display:grid;grid-template-columns:repeat(2, 1fr);gap:16px;}
.grid-3{display:grid;grid-template-columns:repeat(3, 1fr);gap:16px;}
.grid-4{display:grid;grid-template-columns:repeat(4, 1fr);gap:14px;}

/* CARDS */
.card{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:18px;transition:all 0.25s;position:relative;}
.card:hover{border-color:rgba(255,107,107,0.3);box-shadow:var(--shadow);}

.stat-card{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:20px 16px;text-align:center;transition:all 0.25s;}
.stat-card:hover{border-color:rgba(255,107,107,0.3);box-shadow:var(--shadow);transform:translateY(-2px);}
.stat-card .label{font-size:10px;letter-spacing:1px;color:var(--muted);text-transform:uppercase;margin-bottom:6px;font-weight:600;}
.stat-card .value{font-size:28px;font-weight:800;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;margin-bottom:4px;line-height:1.2;}
.stat-card .sub{font-size:10px;color:var(--muted);}

/* BUTTONS */
.btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:12px 20px;border-radius:var(--radius-sm);font-size:13px;font-weight:600;cursor:pointer;border:none;transition:all 0.2s;font-family:'Inter',sans-serif;-webkit-tap-highlight-color:transparent;min-height:44px;user-select:none;}
.btn-primary{background:var(--primary-gradient);color:#fff;box-shadow:0 4px 14px rgba(255,107,107,0.25);}
.btn-primary:hover{box-shadow:0 6px 20px rgba(255,107,107,0.35);transform:translateY(-1px);}
.btn-primary:active{transform:translateY(0);box-shadow:0 2px 8px rgba(255,107,107,0.2);}
.btn-secondary{background:var(--card);color:var(--text);border:1.5px solid var(--border);}
.btn-secondary:hover{border-color:var(--accent);color:var(--accent);}
.btn-sm{padding:8px 14px;font-size:12px;min-height:36px;border-radius:8px;}

/* FORMS */
.form-label{font-size:11px;letter-spacing:1px;color:var(--muted);text-transform:uppercase;font-weight:600;margin-bottom:6px;display:block;}
.form-input,.form-select,.form-textarea{width:100%;background:var(--surface);border:1.5px solid var(--border);border-radius:var(--radius-sm);padding:12px 14px;font-size:14px;color:var(--text);font-family:'Inter',sans-serif;outline:none;transition:all 0.2s;-webkit-appearance:none;min-height:44px;}
.form-input:focus,.form-select:focus,.form-textarea:focus{border-color:var(--accent);box-shadow:0 0 0 3px rgba(255,107,107,0.1);}
.form-textarea{resize:vertical;min-height:100px;}

/* SCHEDULE */
.schedule-item{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);margin-bottom:8px;overflow:hidden;transition:all 0.2s;}
.schedule-item:hover{border-color:rgba(255,107,107,0.3);}
.schedule-hdr{display:flex;align-items:center;gap:12px;padding:14px 16px;cursor:pointer;-webkit-tap-highlight-color:transparent;min-height:56px;}
.sch-dot{width:10px;height:10px;border-radius:50%;flex-shrink:0;}
.sch-title{flex:1;font-weight:600;font-size:13px;line-height:1.3;}
.sch-time{font-size:11px;color:var(--muted);flex-shrink:0;min-width:60px;text-align:right;}
.sch-check{width:28px;height:28px;border-radius:50%;border:2px solid var(--border);display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;transition:all 0.2s;background:var(--card);font-size:14px;-webkit-tap-highlight-color:transparent;}
.sch-check:hover{border-color:var(--accent);}
.sch-check.checked{background:var(--success);border-color:var(--success);color:#fff;}

/* PHASE CARD */
.phase-card{background:var(--card);border:1.5px solid var(--border);border-radius:var(--radius);padding:20px;transition:all 0.25s;position:relative;overflow:hidden;}
.phase-card:hover{border-color:rgba(255,107,107,0.3);box-shadow:var(--shadow);transform:translateY(-2px);}
.phase-name{font-weight:700;font-size:15px;margin-bottom:4px;}
.phase-sub{font-size:12px;color:var(--muted);margin-bottom:8px;}

/* MODAL */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}
.modal{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:24px;width:100%;max-width:480px;max-height:90vh;overflow-y:auto;box-shadow:var(--shadow-lg);}
.modal-title{font-family:'IBM Plex Mono',monospace;font-size:18px;font-weight:800;margin-bottom:20px;letter-spacing:0.5px;}

/* LOGIN */
.login-bg{min-height:100vh;min-height:100dvh;background:linear-gradient(160deg, var(--bg) 0%, var(--surface) 50%, var(--bg) 100%);display:flex;align-items:center;justify-content:center;padding:20px;}
.login-box{background:var(--card);border:1px solid var(--border);border-radius:20px;padding:32px 28px;width:100%;max-width:380px;box-shadow:var(--shadow-lg);}
.login-logo{font-family:'IBM Plex Mono',monospace;font-size:24px;font-weight:800;letter-spacing:2px;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-align:center;margin-bottom:6px;text-transform:uppercase;}
.login-sub{font-size:11px;color:var(--muted);letter-spacing:1px;text-align:center;margin-bottom:28px;text-transform:uppercase;}
.login-input{width:100%;background:var(--surface);border:1.5px solid var(--border);border-radius:var(--radius-sm);padding:14px 16px;font-size:14px;color:var(--text);font-family:'Inter',sans-serif;margin-bottom:12px;transition:all 0.2s;outline:none;min-height:48px;}
.login-input:focus{border-color:var(--accent);box-shadow:0 0 0 3px rgba(255,107,107,0.1);}
.login-btn{width:100%;background:var(--primary-gradient);color:#fff;border:none;border-radius:var(--radius-sm);padding:14px;font-size:14px;font-weight:700;font-family:'Inter',sans-serif;letter-spacing:1px;cursor:pointer;transition:all 0.2s;min-height:48px;box-shadow:0 4px 14px rgba(255,107,107,0.25);}
.login-btn:hover{box-shadow:0 6px 20px rgba(255,107,107,0.35);transform:translateY(-1px);}
.login-btn:active{transform:translateY(0);}
.login-btn:disabled{opacity:0.7;cursor:default;transform:none;}

/* NOTE CARD */
.note-card{background:var(--card);border-left:4px solid;border-radius:var(--radius);padding:16px;margin-bottom:10px;transition:all 0.2s;border-top:1px solid var(--border);border-right:1px solid var(--border);border-bottom:1px solid var(--border);}
.note-card:hover{box-shadow:var(--shadow);}
.note-title{font-weight:700;font-size:14px;margin-bottom:4px;}
.note-content{font-size:13px;color:var(--muted);line-height:1.6;}

/* FLASHCARD */
.flashcard{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:16px;min-height:120px;display:flex;flex-direction:column;cursor:pointer;transition:all 0.25s;-webkit-tap-highlight-color:transparent;}
.flashcard:hover{border-color:rgba(255,107,107,0.3);box-shadow:var(--shadow);}
.flashcard.reviewed{border-color:var(--success);background:rgba(86,171,145,0.05);}

/* PROGRESS RING */
.progress-ring-container{position:relative;width:100px;height:100px;margin:0 auto;}
.progress-ring{transform:rotate(-90deg);width:100px;height:100px;}
.progress-ring-circle{transition:stroke-dashoffset 0.5s ease;}
.progress-ring-text{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;font-weight:700;font-size:22px;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}

/* SCROLLBAR */
::-webkit-scrollbar{width:5px;height:5px;}
::-webkit-scrollbar-track{background:transparent;}
::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px;}

/* ANIMATIONS */
@keyframes fadeIn{from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);}}
.fade-in{animation:fadeIn 0.3s ease;}

/* ===== TABLET ===== */
@media(max-width:1024px){
  .grid-4{grid-template-columns:repeat(2,1fr);}
  .grid-3{grid-template-columns:repeat(2,1fr);}
  .sidebar{width:200px;min-width:200px;}
}

/* ===== MOBILE ===== */
@media(max-width:768px){
  .sidebar{display:none !important;}
  .topbar{display:none !important;}

  .mobile-topbar{
    display:flex !important;
    align-items:center;
    justify-content:space-between;
    padding:12px 16px;
    background:var(--surface);
    border-bottom:1px solid var(--border);
    flex-shrink:0;
    min-height:52px;
    gap:8px;
  }
  .mobile-topbar .mob-logo{
    font-family:'IBM Plex Mono',monospace;
    font-size:14px;font-weight:800;
    color:var(--accent);letter-spacing:1.5px;
  }
  .mobile-topbar .mob-stats{
    display:flex;gap:8px;align-items:center;font-size:11px;color:var(--muted);
  }
  .mobile-topbar .mob-stats span{
    background:var(--card);border:1px solid var(--border);
    padding:4px 8px;border-radius:16px;font-weight:600;font-size:10px;
    white-space:nowrap;
  }

  .bottom-nav{
    display:flex !important;
    background:var(--surface);
    border-top:1px solid var(--border);
    padding:4px 0;
    padding-bottom:max(4px, env(safe-area-inset-bottom));
    justify-content:space-around;
    align-items:stretch;
    flex-shrink:0;
    z-index:100;
  }
  .bottom-nav-item{
    display:flex;flex-direction:column;align-items:center;justify-content:center;
    padding:6px 2px;cursor:pointer;font-size:9px;color:var(--muted);
    transition:color 0.2s;flex:1;gap:2px;
    -webkit-tap-highlight-color:transparent;min-height:48px;user-select:none;
  }
  .bottom-nav-item .bnav-icon{font-size:18px;line-height:1;}
  .bottom-nav-item.active{color:var(--accent);}
  .bottom-nav-item.active .bnav-icon{transform:scale(1.15);}

  .page{padding:16px 14px;}
  .page-title{font-size:18px;letter-spacing:0.5px;}
  .page-sub{font-size:12px;margin-bottom:16px;}

  .grid-auto{grid-template-columns:1fr;}
  .grid-2{grid-template-columns:1fr;}
  .grid-3{grid-template-columns:1fr;}
  .grid-4{grid-template-columns:repeat(2,1fr);gap:10px;}

  .stat-card{padding:14px 12px;}
  .stat-card .value{font-size:22px;}
  .stat-card .label{font-size:9px;letter-spacing:0.5px;}

  .card{padding:14px;border-radius:12px;}

  .schedule-hdr{padding:12px 14px;min-height:52px;}
  .sch-check{width:32px;height:32px;font-size:16px;}
  .sch-title{font-size:13px;}
  .sch-dot{width:8px;height:8px;}

  .btn{padding:12px 18px;font-size:13px;min-height:46px;width:100%;justify-content:center;border-radius:12px;}
  .btn-sm{min-height:38px;width:auto;padding:8px 14px;}

  .modal-overlay{padding:0;align-items:flex-end;}
  .modal{max-width:100%;border-radius:20px 20px 0 0;max-height:85vh;padding:24px 20px;padding-bottom:max(24px, env(safe-area-inset-bottom));}
  .modal-title{font-size:16px;}
  .form-input,.form-select{min-height:48px;font-size:15px;}
  .form-textarea{font-size:15px;}

  .phase-card{padding:16px;}
  .phase-name{font-size:14px;}

  .flashcard{padding:14px;min-height:110px;}

  .login-box{padding:28px 22px;border-radius:16px;max-width:100%;}
  .login-logo{font-size:20px;}
  .login-input{padding:14px;font-size:15px;min-height:50px;}
  .login-btn{min-height:50px;font-size:14px;}
}

/* ===== SMALL PHONES ===== */
@media(max-width:380px){
  .grid-4{grid-template-columns:1fr;}
  .page{padding:12px 10px;}
  .mobile-topbar{padding:10px 12px;}
  .bottom-nav-item{font-size:8px;padding:4px 1px;}
  .bottom-nav-item .bnav-icon{font-size:16px;}
}

/* ===== VOCAB MASTER ===== */
.progress-ring-container{position:relative;width:140px;height:140px;margin:0 auto;}
.progress-ring{width:100%;height:100%;transform:rotate(-90deg);}
.progress-ring-circle{transition:stroke-dashoffset 0.6s ease;}
.progress-ring-text{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;font-size:22px;font-weight:800;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.vocab-flashcard-flip{perspective:1000px;}
`;

export default function App() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem('upsc_study_auth') === 'true');
  const [page, setPage] = useState('dashboard');
  const [theme, setTheme] = useState('dark-mode');
  
  const [startDate, setStartDateState] = useState(null);
  const [todaySchedule, setTodaySchedule] = useState({});
  const [studyLog, setStudyLog] = useState([]);
  const [notes, setNotes] = useState([]);
  const [flashcards, setFlashcards] = useState([]);
  const [mockTests, setMockTests] = useState([]);
  const [dailyHistory, setDailyHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [, setStats] = useState({});

  const today = getTodayKey();

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  useEffect(() => {
    if (!authed) return;
    async function loadAll() {
      setLoading(true);
      try {
        const [sched,st,sl,n,fc,mt,sd,dh] = await Promise.all([
          dbGetSchedule(today), dbGetStats(), dbGetStudyLog(),
          dbGetNotes(), dbGetFlashcards(), dbGetMockTests(), dbGetStartDate(), dbGetDailyHistory(),
        ]);
        setTodaySchedule(sched); setStats(st); setStudyLog(sl); setNotes(n); setFlashcards(fc); setMockTests(mt); setDailyHistory(dh);
        if (sd) setStartDateState(sd); else { const d=getTodayKey(); setStartDateState(d); await dbSetStartDate(d); }
      } catch(err) { console.error(err); }
      setLoading(false);
    }
    loadAll();
  }, [authed, today]);

  useEffect(() => {
    if (!authed) return;
    const ch = supabase.channel('upsc-rt')
      .on('postgres_changes',{event:'*',schema:'public',table:'daily_schedule'}, async()=>setTodaySchedule(await dbGetSchedule(today)))
      .on('postgres_changes',{event:'*',schema:'public',table:'notes'}, async()=>setNotes(await dbGetNotes()))
      .on('postgres_changes',{event:'*',schema:'public',table:'flashcards'}, async()=>setFlashcards(await dbGetFlashcards()))
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [authed, today]);

  async function toggleScheduleMain(id) {
    const prev = todaySchedule[id]||{};
    const newTasks = {...todaySchedule,[id]:{...prev,done:!prev.done}};
    setTodaySchedule(newTasks);
    await dbUpsertSchedule(today,newTasks);
  }
  async function addNote(note) { const n = await dbAddNote(note); if(n) setNotes(s=>[n,...s]); }
  async function deleteNote(id) { await dbDeleteNote(id); setNotes(s=>s.filter(n=>n.id!==id)); }
  async function addFlashcard(card) { const c = await dbAddFlashcard(card); if(c) setFlashcards(s=>[c,...s]); }
  async function updateFlashcardReviewed(id, reviewed) { await dbUpdateFlashcard(id, reviewed); setFlashcards(s=>s.map(f=>f.id===id?{...f,reviewed}:f)); }
  async function deleteFlashcard(id) { await dbDeleteFlashcard(id); setFlashcards(s=>s.filter(f=>f.id!==id)); }
  async function addStudyLog(log) { const n = await dbAddStudyLog(log); if(n) setStudyLog(s=>[n,...s]); }
  async function addMockTest(t) { const n = await dbAddMockTest(t); if(n) setMockTests(s=>[{...n,testType:n.test_type,testName:n.test_name,maxScore:n.max_score},...s]); }

  if (!authed) return (<><style>{CSS}</style><LoginPage onLogin={()=>setAuthed(true)}/></>);
  if (loading) return (<><style>{CSS}</style><div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}><div style={{textAlign:'center'}}><div style={{fontSize:'32px',fontWeight:800,background:'var(--primary-gradient)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text',marginBottom:'12px'}}>UPSC MASTERY</div><div style={{color:'var(--muted)'}}>Loading your journey...</div></div></div></>);

  const completedToday = DAILY_SCHEDULE.filter(s=>todaySchedule[s.id]?.done).length;
  const dayNumber = getDayNumber(startDate);
  const daysRemaining = calcDaysRemaining();

  const navItems = [
    {id:'dashboard',icon:'◉',label:'Dashboard'},
    {id:'schedule',icon:'⏱',label:'Schedule'},
    {id:'phases',icon:'🎯',label:'8 Phases'},
    {id:'library',icon:'📖',label:'Library'},
    {id:'pyq',icon:'📄',label:'PYQ Papers'},
    {id:'history',icon:'📊',label:'History'},
    {id:'notes',icon:'📓',label:'Notes'},
    {id:'flashcards',icon:'🎴',label:'Flashcards'},
    {id:'vocab',icon:'📚',label:'Vocabulary'},
    {id:'study',icon:'📝',label:'Study Log'},
    {id:'mockests',icon:'📋',label:'Mocks'},
    {id:'settings',icon:'⚙',label:'Settings'},
  ];

const mobileNav = [
      {id:'dashboard',icon:'◉',label:'Home'},
      {id:'schedule',icon:'⏱',label:'Schedule'},
      {id:'vocab',icon:'📚',label:'Vocab'},
      {id:'notes',icon:'📓',label:'Notes'},
      {id:'history',icon:'📊',label:'More'},
    ];

    return (
      <>
        <style>{CSS}</style>
        <div className="app">
          {/* Desktop Sidebar */}
          <div className="sidebar">
            <div className="sidebar-logo">
              <div style={{flex:1}}>
                <h1>UPSC</h1>
                <div className="sub">Mastery</div>
              </div>
              <button className="theme-toggle" onClick={()=>setTheme(t=>t==='dark-mode'?'light-mode':'dark-mode')} title="Toggle theme">
                {theme==='dark-mode'?'☀️':'🌙'}
              </button>
            </div>

            <div className="nav-section">
              {navItems.map(n=>(
                <div key={n.id} className={`nav-item ${page===n.id?'active':''}`} onClick={()=>setPage(n.id)}>
                  <span className="icon">{n.icon}</span><span>{n.label}</span>
                </div>
              ))}
            </div>

            <div className="sidebar-stat">
              <div className="label">Day</div>
              <div className="val">#{dayNumber}</div>
            </div>
            <div className="sidebar-stat">
              <div className="label">Completion</div>
              <div className="val">{completedToday}/{DAILY_SCHEDULE.length}</div>
            </div>

            <div className="sidebar-bottom">
              <button className="logout-btn" onClick={()=>{sessionStorage.removeItem('upsc_study_auth');setAuthed(false);}}>Logout</button>
            </div>
          </div>

          {/* Main area */}
          <div className="main-area">
            {/* Mobile Top Bar */}
            <div className="mobile-topbar">
              <div className="mob-logo">UPSC</div>
              <div className="mob-stats">
                <span>{completedToday}/{DAILY_SCHEDULE.length} ✓</span>
                <span>Day #{dayNumber}</span>
                <button className="theme-toggle" onClick={()=>setTheme(t=>t==='dark-mode'?'light-mode':'dark-mode')} style={{padding:'4px 8px',fontSize:'14px',minHeight:'auto'}}>
                  {theme==='dark-mode'?'☀️':'🌙'}
                </button>
              </div>
            </div>

            {/* Desktop Topbar */}
            <div className="topbar">
              <div className="topbar-pill"><span className="lbl">Phase</span><span className="val">Prep</span></div>
              <div className="topbar-pill"><span className="lbl">Tests</span><span className="val">{mockTests.length}</span></div>
              <div className="topbar-pill"><span className="lbl">Notes</span><span className="val">{notes.length}</span></div>
              <div className="topbar-pill"><span className="lbl">Cards</span><span className="val">{flashcards.length}</span></div>
              <div className="topbar-pill" style={{marginLeft:'auto'}}><span className="val">{new Date().toLocaleDateString('en-IN',{weekday:'short',month:'short',day:'numeric'})}</span></div>
            </div>

            {/* Pages */}
            <div className="page-scroll">
              {page==='dashboard' && <DashboardPage completedToday={completedToday} dayNumber={dayNumber} daysRemaining={daysRemaining} notes={notes} flashcards={flashcards} mockTests={mockTests} studyLog={studyLog}/>}
              {page==='schedule' && <SchedulePage schedule={todaySchedule} toggleMain={toggleScheduleMain} completedToday={completedToday}/>}
              {page==='phases' && <PhasesPage/>}
              {page==='library' && <LibraryPage/>}
              {page==='pyq' && <PYQPage/>}
              {page==='history' && <HistoryPage dailyHistory={dailyHistory} daysRemaining={daysRemaining} notes={notes} flashcards={flashcards} setPage={setPage}/>}
              {page==='notes' && <NotesPage notes={notes} addNote={addNote} deleteNote={deleteNote} setModal={setModal}/>}
              {page==='flashcards' && <FlashcardsPage flashcards={flashcards} addFlashcard={addFlashcard} updateFlashcardReviewed={updateFlashcardReviewed} deleteFlashcard={deleteFlashcard} setModal={setModal}/>}
              {page==='vocab' && <VocabMaster/>}
              {page==='study' && <StudyPage studyLog={studyLog} addStudyLog={addStudyLog} setModal={setModal}/>}
              {page==='mockests' && <MockTestsPage mockTests={mockTests} addMockTest={addMockTest} setModal={setModal}/>}
              {page==='settings' && <SettingsPage startDate={startDate} updateStartDate={async(d)=>{setStartDateState(d);await dbSetStartDate(d);}} onLogout={()=>{sessionStorage.removeItem('upsc_study_auth');setAuthed(false);}}/>}
            </div>

            {/* Mobile Bottom Nav */}
            <div className="bottom-nav">
              {mobileNav.map(n=>(
                <div key={n.id} className={`bottom-nav-item ${page===n.id?'active':''}`} onClick={()=>setPage(n.id)}>
                  <span className="bnav-icon">{n.icon}</span>
                  <span>{n.label}</span>
                </div>
              ))}
          </div>
        </div>
      </div>

      {modal==='note' && <NoteModal onClose={()=>setModal(null)} onSubmit={d=>{addNote(d);setModal(null);}}/>}
      {modal==='flashcard' && <FlashcardModal onClose={()=>setModal(null)} onSubmit={d=>{addFlashcard(d);setModal(null);}}/>}
      {modal==='study' && <StudyModal onClose={()=>setModal(null)} onSubmit={d=>{addStudyLog(d);setModal(null);}}/>}
      {modal==='mocktest' && <MockTestModal onClose={()=>setModal(null)} onSubmit={d=>{addMockTest(d);setModal(null);}}/>}
    </>
  );
}

function LoginPage({onLogin}) {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [quote] = useState(()=>getRandomQuote());

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setErr('');
    setTimeout(() => {
      if (u.trim() === VALID_USERNAME && p === VALID_PASSWORD) {
        sessionStorage.setItem('upsc_study_auth','true');
        onLogin();
      } else {
        setErr('Invalid credentials. Try again.');
      }
      setLoading(false);
    }, 600);
  }

  return (
    <div className="login-bg">
      <div className="login-box">
        <div className="login-logo">🎯 UPSC Mastery</div>
        <div className="login-sub">Your Path to IAS Success</div>
        
<div style={{background:'rgba(255,107,107,0.08)',border:'1px solid rgba(255,107,107,0.15)',borderRadius:'12px',padding:'14px',marginBottom:'20px',fontSize:'13px',color:'var(--text)',lineHeight:'1.6',fontStyle:'italic',textAlign:'center'}}>
            "{quote}"
        </div>

        {err && <div style={{background:'rgba(255,107,107,0.15)',border:'1px solid rgba(255,107,107,0.3)',borderRadius:'10px',padding:'11px',fontSize:'12px',color:'#ff6b6b',marginBottom:'14px'}}>{err}</div>}
        
        <form onSubmit={handleSubmit}>
          <input className="login-input" type="text" placeholder="Username" value={u} onChange={e=>setU(e.target.value)} autoComplete="username"/>
          <input className="login-input" type="password" placeholder="Password" value={p} onChange={e=>setP(e.target.value)} autoComplete="current-password"/>
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? '⏳ LOADING...' : '🚀 BEGIN YOUR JOURNEY'}
          </button>
        </form>

        <div style={{textAlign:'center',marginTop:'20px',fontSize:'11px',color:'var(--muted)'}}>
          Default: upsc / StudySuccess2028
        </div>
      </div>
    </div>
  );
}

function DashboardPage({completedToday,dayNumber,daysRemaining,notes,flashcards,mockTests,studyLog}) {
  const motivation = getRandomQuote();
  const studyHours = studyLog.reduce((s,log)=>s+(parseInt(log.duration)||0),0)/60;
  const revisionRate = notes.length>0 ? Math.round(flashcards.length/notes.length*100) : 0;

  return (
    <div className="page">
      <div style={{background:'linear-gradient(135deg, rgba(255,107,107,0.08), rgba(78,205,196,0.08))',border:'1px solid var(--border)',borderRadius:'var(--radius, 14px)',padding:'16px',marginBottom:'24px',display:'flex',alignItems:'center',gap:'14px'}}>
        <div style={{fontSize:'32px',flexShrink:0}}>⚡</div>
        <div style={{minWidth:0}}>
          <div style={{fontSize:'13px',fontWeight:700,color:'var(--text)',marginBottom:'2px'}}>Daily Motivation</div>
          <div style={{fontSize:'12px',color:'var(--muted)',lineHeight:'1.5',fontStyle:'italic',overflow:'hidden',textOverflow:'ellipsis'}}>"{motivation}"</div>
        </div>
      </div>

      <div className="grid-4">
        <div className="stat-card">
          <div className="label">🎯 Today's Completion</div>
          <div className="value">{completedToday}/{DAILY_SCHEDULE.length}</div>
          <div className="sub">{Math.round(completedToday/DAILY_SCHEDULE.length*100)}% Complete</div>
        </div>
        <div className="stat-card">
          <div className="label">📚 Study Sessions</div>
          <div className="value">{Math.round(studyHours)}</div>
          <div className="sub">Hours Logged</div>
        </div>
        <div className="stat-card">
          <div className="label">📝 Notes Created</div>
          <div className="value">{notes.length}</div>
          <div className="sub">{revisionRate}% Revision</div>
        </div>
        <div className="stat-card">
          <div className="label">🎴 Flashcards</div>
          <div className="value">{flashcards.length}</div>
          <div className="sub">Active Recall</div>
        </div>
      </div>

      <div style={{marginTop:'24px',marginBottom:'24px'}}>
          <h2 style={{fontSize:'14px',fontWeight:700,marginBottom:'12px'}}>📊 Quick Stats</h2>
        <div className="grid-3">
          <div className="card">
            <div style={{fontSize:'12px',color:'var(--muted)',fontWeight:600,marginBottom:'8px'}}>Day Number</div>
            <div style={{fontSize:'28px',fontWeight:800,background:'var(--primary-gradient)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text'}}># {dayNumber}</div>
          </div>
          <div className="card">
            <div style={{fontSize:'12px',color:'var(--muted)',fontWeight:600,marginBottom:'8px'}}>Days to Exam</div>
            <div style={{fontSize:'28px',fontWeight:800,color:'var(--accent)'}}>{daysRemaining}</div>
          </div>
          <div className="card">
            <div style={{fontSize:'12px',color:'var(--muted)',fontWeight:600,marginBottom:'8px'}}>Mock Tests</div>
            <div style={{fontSize:'28px',fontWeight:800,color:'var(--success)'}}>{mockTests.length}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SchedulePage({schedule,toggleMain,completedToday}) {
  return (
    <div className="page">
      <h1 className="page-title">⏱ DAILY SCHEDULE</h1>
        <p className="page-sub">{completedToday}/{DAILY_SCHEDULE.length} completed • {Math.round(completedToday/DAILY_SCHEDULE.length*100)}%</p>
      {DAILY_SCHEDULE.map(item=>(
        <div key={item.id} className="schedule-item" style={{opacity:schedule[item.id]?.done?0.6:1,backgroundColor:schedule[item.id]?.done?'rgba(86,171,145,0.05)':''}}>
          <div className="schedule-hdr" onClick={()=>toggleMain(item.id)}>
            <div className="sch-dot" style={{background:item.color}}/>
            <div style={{flex:1}}>
              <div className="sch-title">{item.title}</div>
              <div className="sch-time">{item.time}</div>
            </div>
            <div className="sch-check" style={{borderColor:schedule[item.id]?.done?'var(--success)':'var(--border)',background:schedule[item.id]?.done?'var(--success)':'transparent'}}>
              {schedule[item.id]?.done && '✓'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function PhasesPage() {
  return (
    <div className="page">
      <h1 className="page-title">🎯 8 PHASES TO IAS</h1>
      <p className="page-sub">12-15 months intensive preparation • Stay focused, stay strong</p>
      
      <div className="grid-auto">
        {PHASES.map((phase,idx)=>(
          <div key={phase.id} className="phase-card" style={{borderColor:phase.color}}>
            <div style={{fontSize:'32px',marginBottom:'8px'}}>{phase.icon}</div>
            <div className="phase-name" style={{color:phase.color}}>{phase.name}</div>
            <div className="phase-sub">{phase.subname}</div>
            <div style={{fontSize:'11px',color:'var(--muted)',marginTop:'12px'}}>🎯 {phase.tasks} tasks</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function HistoryPage({dailyHistory,daysRemaining,notes,flashcards,setPage}) {
  const last30 = [];
  for(let i=0;i<30;i++){const d=new Date();d.setDate(d.getDate()-i);last30.unshift({date:d.toISOString().slice(0,10)});}
  const historyMap = Object.fromEntries(dailyHistory.map(d=>[d.date,calcCompletionRate(d.tasks)]));
  const avgCompletion = dailyHistory.length>0 ? Math.round(dailyHistory.reduce((s,d)=>s+calcCompletionRate(d.tasks),0)/dailyHistory.length) : 0;

  return (
    <div className="page">
      <h1 className="page-title">📊 YOUR JOURNEY</h1>
      <p className="page-sub">Track progress • Stay motivated • Achieve your goal</p>
      
      <div className="grid-4" style={{marginBottom:'28px'}}>
        <div className="stat-card">
          <div className="label">📅 Days Remaining</div>
          <div className="value" style={{color:'var(--accent)'}}>{daysRemaining}</div>
          <div className="sub">Till May 2027</div>
        </div>
        <div className="stat-card">
          <div className="label">📈 Avg Completion</div>
          <div className="value" style={{color:'var(--success)'}}>{avgCompletion}%</div>
          <div className="sub">30-day average</div>
        </div>
        <div className="stat-card">
          <div className="label">📝 Notes</div>
          <div className="value" style={{color:'var(--warning)'}}>{notes.length}</div>
          <div className="sub">Study notes created</div>
        </div>
        <div className="stat-card">
          <div className="label">🎴 Flashcards</div>
          <div className="value" style={{color:'#4ECDC4'}}>{flashcards.length}</div>
          <div className="sub">Active recall deck</div>
        </div>
      </div>

      <h2 style={{fontSize:'14px',fontWeight:700,marginBottom:'12px'}}>30-Day Completion Heatmap</h2>
      <div className="card" style={{padding:'24px',marginBottom:'28px'}}>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7, 1fr)',gap:'8px'}}>
          {last30.map(d=>{const rate=historyMap[d.date]||0;const colors=['#444','rgba(255,107,107,0.3)','rgba(255,107,107,0.6)','var(--accent)'];const colorIdx=rate===0?0:rate<50?1:rate<75?2:3;return(<div key={d.date} style={{aspectRatio:'1',background:colors[colorIdx],borderRadius:'8px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'12px',fontWeight:700,color:'var(--text)',cursor:'pointer',transition:'all 0.2s',border:'1px solid var(--border)'}} title={`${d.date}: ${rate}%`}>{new Date(d.date).getDate()}</div>);})}
        </div>
      </div>
    </div>
  );
}

const LIBRARY_DATA = [
  {
    phase: 'Phase 1: Foundation',
    phaseIcon: '⚡',
    phaseColor: '#FF6B6B',
    sections: [
      {
        name: 'NCERT Books',
        icon: '📖',
        classes: [
          {
            className: 'Class 6',
            books: [
              { title: 'Our Pasts – I (History)', subject: 'History', file: '/files/History_Class6_UPSC_Notes.html', icon: '🏛️' },
            ]
          },
          {
            className: 'Class 7',
            books: []
          },
          {
            className: 'Class 8',
            books: []
          },
          {
            className: 'Class 9',
            books: []
          },
          {
            className: 'Class 10',
            books: []
          },
          {
            className: 'Class 11',
            books: []
          },
          {
            className: 'Class 12',
            books: []
          },
        ]
      }
    ]
  },
];

function LibraryPage() {
  const [openPhase, setOpenPhase] = useState(0);
  const [openClass, setOpenClass] = useState(null);
  const [viewingBook, setViewingBook] = useState(null);

  if (viewingBook) {
    return (
      <div style={{display:'flex',flexDirection:'column',height:'calc(100dvh - 56px)'}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px',padding:'12px 16px',background:'var(--surface)',borderBottom:'1px solid var(--border)',flexShrink:0}}>
          <button className="btn btn-sm btn-secondary" onClick={()=>setViewingBook(null)} style={{width:'auto',minHeight:'36px',padding:'6px 14px'}}>← Back</button>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:'13px',fontWeight:700,color:'var(--text)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{viewingBook.title}</div>
            <div style={{fontSize:'10px',color:'var(--muted)'}}>{viewingBook.subject}</div>
          </div>
          <a href={viewingBook.file} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary" style={{width:'auto',minHeight:'36px',padding:'6px 14px',textDecoration:'none'}}>↗ Open</a>
        </div>
        <iframe
          src={viewingBook.file}
          title={viewingBook.title}
          style={{flex:1,border:'none',width:'100%',background:'#fff'}}
        />
      </div>
    );
  }

  return (
    <div className="page">
      <h1 className="page-title">📖 STUDY LIBRARY</h1>
      <p className="page-sub">NCERT Books & Study Materials • Organized by Phase & Class</p>

      {LIBRARY_DATA.map((phase, phaseIdx) => (
        <div key={phaseIdx} style={{marginBottom:'20px'}}>
          <div
            className="card"
            style={{cursor:'pointer',borderLeft:`4px solid ${phase.phaseColor}`,marginBottom:openPhase===phaseIdx?'0':'0',borderRadius:openPhase===phaseIdx?'var(--radius) var(--radius) 0 0':'var(--radius)'}}
            onClick={()=>setOpenPhase(openPhase===phaseIdx?null:phaseIdx)}
          >
            <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
              <span style={{fontSize:'24px'}}>{phase.phaseIcon}</span>
              <div style={{flex:1}}>
                <div style={{fontSize:'15px',fontWeight:700,color:'var(--text)'}}>{phase.phase}</div>
                <div style={{fontSize:'11px',color:'var(--muted)'}}>NCERT Foundation</div>
              </div>
              <span style={{fontSize:'18px',color:'var(--muted)',transition:'transform 0.2s',transform:openPhase===phaseIdx?'rotate(180deg)':'rotate(0)'}}>▼</span>
            </div>
          </div>

          {openPhase===phaseIdx && phase.sections.map((section, secIdx) => (
            <div key={secIdx} style={{background:'var(--surface)',border:'1px solid var(--border)',borderTop:'none',borderRadius:'0 0 var(--radius) var(--radius)',overflow:'hidden'}}>
              {section.classes.map((cls, clsIdx) => {
                const hasBooks = cls.books && cls.books.length > 0;
                const isOpen = openClass === `${phaseIdx}-${clsIdx}`;
                return (
                  <div key={clsIdx}>
                    <div
                      style={{display:'flex',alignItems:'center',gap:'10px',padding:'12px 16px',cursor:hasBooks?'pointer':'default',borderBottom:'1px solid var(--border)',opacity:hasBooks?1:0.5,transition:'background 0.2s',background:isOpen?'var(--card)':'transparent'}}
                      onClick={()=>hasBooks && setOpenClass(isOpen?null:`${phaseIdx}-${clsIdx}`)}
                    >
                      <span style={{fontSize:'14px'}}>📚</span>
                      <span style={{flex:1,fontSize:'13px',fontWeight:600,color:'var(--text)'}}>{cls.className}</span>
                      {hasBooks ? (
                        <span style={{background:'rgba(255,107,107,0.15)',color:'var(--accent)',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:700}}>{cls.books.length} book{cls.books.length>1?'s':''}</span>
                      ) : (
                        <span style={{fontSize:'10px',color:'var(--muted)',fontStyle:'italic'}}>Coming soon</span>
                      )}
                    </div>
                    {isOpen && cls.books.map((book, bookIdx) => (
                      <div
                        key={bookIdx}
                        style={{display:'flex',alignItems:'center',gap:'12px',padding:'12px 16px 12px 42px',borderBottom:'1px solid var(--border)',cursor:'pointer',background:'var(--card)',transition:'background 0.2s'}}
                        onClick={()=>setViewingBook(book)}
                      >
                        <span style={{fontSize:'20px'}}>{book.icon}</span>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:'13px',fontWeight:600,color:'var(--text)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{book.title}</div>
                          <div style={{fontSize:'10px',color:'var(--muted)'}}>{book.subject}</div>
                        </div>
                        <span style={{fontSize:'18px',color:'var(--accent)'}}>→</span>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      ))}

      <div className="card" style={{textAlign:'center',padding:'24px',background:'rgba(255,107,107,0.05)',border:'1px dashed var(--border)'}}>
        <div style={{fontSize:'24px',marginBottom:'8px'}}>📁</div>
        <div style={{fontSize:'13px',color:'var(--muted)'}}>More books coming soon! Place .html files in <code>/public/files/</code> and update the library catalog.</div>
      </div>
    </div>
  );
}

/* ===== PYQ DATA & COMPONENT ===== */
const PYQ_DATA = [
  {year:2024, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers'},
  ], topperSheets:[
    {name:'AIR 1 Aditya Srivastava — Answer Copy',url:'https://www.google.com/search?q=UPSC+2024+topper+Aditya+Srivastava+answer+copy+PDF'},
  ]},
  {year:2023, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers'},
  ], topperSheets:[
    {name:'AIR 1 Aditya Srivastava — Answer Copy',url:'https://www.google.com/search?q=UPSC+2023+topper+answer+copy+PDF'},
  ]},
  {year:2022, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[
    {name:'AIR 1 Ishita Kishore — Answer Copy',url:'https://www.google.com/search?q=UPSC+2022+topper+Ishita+Kishore+answer+copy+PDF'},
  ]},
  {year:2021, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[
    {name:'AIR 1 Shruti Sharma — Answer Copy',url:'https://www.google.com/search?q=UPSC+2021+topper+Shruti+Sharma+answer+copy+PDF'},
  ]},
  {year:2020, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[
    {name:'AIR 1 Shubham Kumar — Answer Copy',url:'https://www.google.com/search?q=UPSC+2020+topper+Shubham+Kumar+answer+copy+PDF'},
  ]},
  {year:2019, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[
    {name:'AIR 1 Pradeep Singh — Answer Copy',url:'https://www.google.com/search?q=UPSC+2019+topper+Pradeep+Singh+answer+copy+PDF'},
  ]},
  {year:2018, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[]},
  {year:2017, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[]},
  {year:2016, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[]},
  {year:2015, prelims:[
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'CSAT Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], mains:[
    {name:'Essay',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper I',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper II',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper III',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
    {name:'GS Paper IV (Ethics)',url:'https://upsc.gov.in/examinations/previous-question-papers/archives'},
  ], topperSheets:[]},
];

function PYQPage() {
  const [expandedYear, setExpandedYear] = React.useState(null);
  const [expandedSection, setExpandedSection] = React.useState(null);

  const openPaper = (paper) => {
    window.open(paper.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="page">
      <h1 className="page-title">📄 PREVIOUS YEAR QUESTIONS</h1>
      <p className="page-sub">10 Years of UPSC CSE Papers • Prelims + Mains + Topper Copies</p>

      {/* Quick Access Banner */}
      <div style={{background:'linear-gradient(135deg,rgba(var(--accent-rgb,99,102,241),0.15),rgba(var(--accent-rgb,99,102,241),0.05))',borderRadius:'16px',padding:'18px 20px',marginBottom:'16px',border:'1px solid var(--border)'}}>
        <p style={{margin:'0 0 10px',fontSize:'14px',fontWeight:700}}>🌐 Quick Access — Official Sources</p>
        <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
          <a href="https://upsc.gov.in/examinations/previous-question-papers" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{fontSize:'12px',padding:'8px 14px',textDecoration:'none'}}>📋 UPSC Official — Latest Papers</a>
          <a href="https://upsc.gov.in/examinations/previous-question-papers/archives" target="_blank" rel="noopener noreferrer" className="btn btn-secondary" style={{fontSize:'12px',padding:'8px 14px',textDecoration:'none'}}>🗄️ UPSC Archives (2015–2023)</a>
          <a href="https://upsc.gov.in/examinations/answer-key" target="_blank" rel="noopener noreferrer" className="btn btn-secondary" style={{fontSize:'12px',padding:'8px 14px',textDecoration:'none'}}>🔑 Official Answer Keys</a>
        </div>
      </div>

      {/* Tip */}
      <div style={{background:'rgba(251,191,36,0.08)',borderRadius:'12px',padding:'12px 16px',marginBottom:'20px',border:'1px solid rgba(251,191,36,0.2)',fontSize:'13px',lineHeight:1.6}}>
        <strong>💡 Tip:</strong> On the UPSC page, select <strong>"Civil Services (Preliminary) Examination"</strong> or <strong>"Civil Services (Main) Examination"</strong> from the dropdown and choose the year. All papers are downloadable PDFs directly from the government site.
      </div>

      {PYQ_DATA.map(yearData => {
        const isYearOpen = expandedYear === yearData.year;
        return (
          <div key={yearData.year} className="card" style={{marginBottom:'12px',cursor:'pointer',overflow:'hidden'}}>
            <div onClick={()=>{setExpandedYear(isYearOpen?null:yearData.year);setExpandedSection(null);}} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'14px'}}>
                <span style={{fontSize:'28px',fontWeight:800,color:'var(--accent)',fontFamily:'monospace'}}>{yearData.year}</span>
                <div>
                  <div style={{fontWeight:700,fontSize:'15px'}}>UPSC CSE {yearData.year}</div>
                  <div style={{fontSize:'12px',opacity:0.6,marginTop:'2px'}}>
                    {yearData.prelims.length} Prelims • {yearData.mains.length} Mains{yearData.topperSheets.length ? ` • ${yearData.topperSheets.length} Topper Copies` : ''}
                  </div>
                </div>
              </div>
              <span style={{fontSize:'18px',transition:'transform 0.3s',transform:isYearOpen?'rotate(180deg)':'rotate(0)'}}>{isYearOpen?'▲':'▼'}</span>
            </div>

            {isYearOpen && (
              <div style={{padding:'0 20px 16px'}}>
                {/* Prelims */}
                <div style={{marginBottom:'10px'}}>
                  <div onClick={(e)=>{e.stopPropagation();setExpandedSection(expandedSection===`${yearData.year}-prelims`?null:`${yearData.year}-prelims`);}} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'rgba(34,197,94,0.1)',borderRadius:'10px',cursor:'pointer',border:'1px solid rgba(34,197,94,0.2)'}}>
                    <span style={{fontWeight:700,color:'rgb(34,197,94)',fontSize:'14px'}}>📗 Prelims Papers</span>
                    <span style={{fontSize:'12px',opacity:0.6}}>{expandedSection===`${yearData.year}-prelims`?'▲':'▼'}</span>
                  </div>
                  {expandedSection===`${yearData.year}-prelims` && (
                    <div style={{padding:'8px 0'}}>
                      {yearData.prelims.map((paper,i) => (
                        <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 16px',borderBottom:'1px solid var(--border)',flexWrap:'wrap',gap:'8px'}}>
                          <span style={{fontSize:'14px',flex:1,minWidth:'120px'}}>{paper.name}</span>
                          <button className="btn btn-primary" onClick={()=>openPaper(paper)} style={{fontSize:'12px',padding:'6px 14px'}}>📖 Open & Download ↗</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Mains */}
                <div style={{marginBottom:'10px'}}>
                  <div onClick={(e)=>{e.stopPropagation();setExpandedSection(expandedSection===`${yearData.year}-mains`?null:`${yearData.year}-mains`);}} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'rgba(59,130,246,0.1)',borderRadius:'10px',cursor:'pointer',border:'1px solid rgba(59,130,246,0.2)'}}>
                    <span style={{fontWeight:700,color:'rgb(59,130,246)',fontSize:'14px'}}>📘 Mains Papers</span>
                    <span style={{fontSize:'12px',opacity:0.6}}>{expandedSection===`${yearData.year}-mains`?'▲':'▼'}</span>
                  </div>
                  {expandedSection===`${yearData.year}-mains` && (
                    <div style={{padding:'8px 0'}}>
                      {yearData.mains.map((paper,i) => (
                        <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 16px',borderBottom:'1px solid var(--border)',flexWrap:'wrap',gap:'8px'}}>
                          <span style={{fontSize:'14px',flex:1,minWidth:'120px'}}>{paper.name}</span>
                          <button className="btn btn-primary" onClick={()=>openPaper(paper)} style={{fontSize:'12px',padding:'6px 14px'}}>📖 Open & Download ↗</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Topper Copies */}
                {yearData.topperSheets.length > 0 && (
                  <div>
                    <div onClick={(e)=>{e.stopPropagation();setExpandedSection(expandedSection===`${yearData.year}-topper`?null:`${yearData.year}-topper`);}} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'rgba(251,191,36,0.1)',borderRadius:'10px',cursor:'pointer',border:'1px solid rgba(251,191,36,0.2)'}}>
                      <span style={{fontWeight:700,color:'rgb(202,138,4)',fontSize:'14px'}}>🏆 Topper Answer Copies</span>
                      <span style={{fontSize:'12px',opacity:0.6}}>{expandedSection===`${yearData.year}-topper`?'▲':'▼'}</span>
                    </div>
                    {expandedSection===`${yearData.year}-topper` && (
                      <div style={{padding:'8px 0'}}>
                        {yearData.topperSheets.map((paper,i) => (
                          <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 16px',borderBottom:'1px solid var(--border)',flexWrap:'wrap',gap:'8px'}}>
                            <span style={{fontSize:'14px',flex:1,minWidth:'120px'}}>{paper.name}</span>
                            <button className="btn btn-primary" onClick={()=>openPaper(paper)} style={{fontSize:'12px',padding:'6px 14px'}}>🔍 Find & Download ↗</button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}

      <div style={{textAlign:'center',padding:'20px',opacity:0.5,fontSize:'13px'}}>
        All papers linked to official UPSC sources • Select exam name & year on the UPSC page to download
      </div>
    </div>
  );
}

function NotesPage({notes,addNote,deleteNote,setModal}) {
  return (
    <div className="page">
      <h1 className="page-title">📓 STUDY NOTES</h1>
      <p className="page-sub">Capture knowledge • Organize concepts • Never forget</p>
      
      <button className="btn btn-primary" style={{marginBottom:'20px'}} onClick={()=>setModal('note')}>+ Create Note</button>

      {notes.length===0?(
        <div className="card" style={{textAlign:'center',padding:'40px',color:'var(--muted)'}}>Create your first note to get started</div>
      ):(
        notes.map(n=>(
          <div key={n.id} className="note-card" style={{borderLeftColor:n.color==='yellow'?'#FFD93D':n.color==='blue'?'#4ECDC4':n.color==='green'?'#56AB91':n.color==='purple'?'#B19CD9':'#FF6B6B'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'8px'}}>
              <div><div className="note-title">{n.title}</div><div style={{fontSize:'10px',color:'var(--muted)'}}>{n.subject}</div></div>
              <button style={{background:'none',border:'none',color:'var(--muted)',cursor:'pointer',fontSize:'14px'}} onClick={()=>deleteNote(n.id)}>✕</button>
            </div>
            <div className="note-content">{n.content}</div>
          </div>
        ))
      )}
    </div>
  );
}

function FlashcardsPage({flashcards,addFlashcard,updateFlashcardReviewed,deleteFlashcard,setModal}) {
  return (
    <div className="page">
      <h1 className="page-title">🎴 FLASHCARDS</h1>
      <p className="page-sub">Active recall • Build long-term memory • Master concepts</p>
      
      <button className="btn btn-primary" style={{marginBottom:'20px'}} onClick={()=>setModal('flashcard')}>+ New Flashcard</button>

      {flashcards.length===0?(
        <div className="card" style={{textAlign:'center',padding:'40px',color:'var(--muted)'}}>Create flashcards for active revision</div>
      ):(
        <div className="grid-auto">
          {flashcards.map(f=>(
            <div key={f.id} className={`flashcard ${f.reviewed?'reviewed':''}`} onClick={()=>updateFlashcardReviewed(f.id,!f.reviewed)} style={{borderColor:f.reviewed?'var(--success)':'var(--border)'}}>
              <div style={{fontSize:'11px',color:'var(--muted)',marginBottom:'8px',textTransform:'uppercase'}}>{f.subject}</div>
              <div style={{fontSize:'14px',fontWeight:700,color:'var(--text)',marginBottom:'8px',minHeight:'30px'}}>{f.front}</div>
              <div style={{fontSize:'12px',color:'var(--muted)',flex:1,marginBottom:'12px'}}>{f.back}</div>
              <button className="btn btn-sm btn-secondary" onClick={e=>{e.stopPropagation();deleteFlashcard(f.id);}}>Delete</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function StudyPage({studyLog,addStudyLog,setModal}) {
  return (
    <div className="page">
      <h1 className="page-title">📚 STUDY LOG</h1>
      <p className="page-sub">Track every study hour • Build consistency • Reach your goal</p>
      
      <button className="btn btn-primary" style={{marginBottom:'20px'}} onClick={()=>setModal('study')}>+ Log Study Session</button>

      {studyLog.length>0?(
        <div className="grid-auto">
          {studyLog.slice(0,20).map(l=>(
            <div key={l.id} className="card">
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'8px'}}>
                <div style={{fontSize:'12px',color:'var(--muted)'}}>{l.date}</div>
                <span style={{background:'rgba(255,107,107,0.2)',color:'var(--accent)',padding:'4px 8px',borderRadius:'6px',fontSize:'10px',fontWeight:600}}>{l.subject}</span>
              </div>
              <div style={{fontSize:'14px',fontWeight:700,color:'var(--text)',marginBottom:'4px'}}>{l.topic}</div>
              <div style={{fontSize:'12px',color:'var(--muted)'}}>⏱ {l.duration} minutes</div>
            </div>
          ))}
        </div>
      ):(
        <div className="card" style={{textAlign:'center',padding:'40px',color:'var(--muted)'}}>Log your study sessions to track progress</div>
      )}
    </div>
  );
}

function MockTestsPage({mockTests,addMockTest,setModal}) {
  return (
    <div className="page">
      <h1 className="page-title">📝 MOCK TESTS</h1>
      <p className="page-sub">Track performance • Identify weak areas • Improve continuously</p>
      
      <button className="btn btn-primary" style={{marginBottom:'20px'}} onClick={()=>setModal('mocktest')}>+ Log Mock Test</button>

      {mockTests.length>0?(
        <div className="grid-2">
          {mockTests.slice(0,20).map(t=>(
            <div key={t.id} className="card">
              <div style={{fontSize:'11px',color:'var(--muted)',marginBottom:'8px',textTransform:'uppercase'}}>{t.testType}</div>
              <div style={{fontSize:'16px',fontWeight:700,color:'var(--text)',marginBottom:'4px'}}>{t.testName}</div>
              <div style={{fontSize:'20px',fontWeight:800,background:'var(--primary-gradient)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text'}}>
                {t.score}{t.maxScore?'/'+t.maxScore:''}
              </div>
              <div style={{fontSize:'11px',color:'var(--muted)',marginTop:'8px'}}>{t.date}</div>
            </div>
          ))}
        </div>
      ):(
        <div className="card" style={{textAlign:'center',padding:'40px',color:'var(--muted)'}}>Log your mock tests to track progress</div>
      )}
    </div>
  );
}

function SettingsPage({startDate,updateStartDate,onLogout}) {
    return (
      <div className="page">
        <h1 className="page-title">⚙ SETTINGS</h1>
        <p className="page-sub">Customize your journey</p>
        
        <div className="card" style={{maxWidth:'400px',marginBottom:'16px'}}>
          <div style={{fontSize:'13px',fontWeight:600,marginBottom:'12px'}}>Your Start Date</div>
          <input className="form-input" type="date" value={startDate||''} onChange={e=>updateStartDate(e.target.value)}/>
        </div>

        {onLogout && (
          <button className="btn btn-secondary" style={{maxWidth:'400px',marginTop:'8px'}} onClick={onLogout}>
            Logout
          </button>
        )}
    </div>
  );
}

function NoteModal({onClose,onSubmit}) {
  const [form,setForm] = useState({title:'',subject:'History',content:'',color:'yellow'});
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">📝 Create Note</div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Title</div>
          <input className="form-input" value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="Note title"/>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Subject</div>
          <select className="form-select" value={form.subject} onChange={e=>setForm(f=>({...f,subject:e.target.value}))}>
            {['History','Geography','Polity','Economy','Environment','Current Affairs','Optional','Essay'].map(s=><option key={s}>{s}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Notes</div>
          <textarea className="form-textarea" value={form.content} onChange={e=>setForm(f=>({...f,content:e.target.value}))} placeholder="Your notes..."/>
        </div>
        <div style={{display:'flex',gap:'12px'}}>
          <button className="btn btn-primary" style={{flex:1}} onClick={()=>{if(form.title&&form.content)onSubmit(form);}}>Save</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function FlashcardModal({onClose,onSubmit}) {
  const [form,setForm] = useState({front:'',back:'',subject:'History'});
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">🎴 New Flashcard</div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Question (Front)</div>
          <input className="form-input" value={form.front} onChange={e=>setForm(f=>({...f,front:e.target.value}))} placeholder="Front of card"/>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Answer (Back)</div>
          <textarea className="form-textarea" value={form.back} onChange={e=>setForm(f=>({...f,back:e.target.value}))} placeholder="Back of card"/>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Subject</div>
          <select className="form-select" value={form.subject} onChange={e=>setForm(f=>({...f,subject:e.target.value}))}>
            {['History','Geography','Polity','Economy','Environment','Current Affairs','Optional','Essay'].map(s=><option key={s}>{s}</option>)}
          </select>
        </div>
        <div style={{display:'flex',gap:'12px'}}>
          <button className="btn btn-primary" style={{flex:1}} onClick={()=>{if(form.front&&form.back)onSubmit(form);}}>Create</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function StudyModal({onClose,onSubmit}) {
  const [form,setForm] = useState({subject:'History',topic:'',duration:''});
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">📚 Log Study</div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Subject</div>
          <select className="form-select" value={form.subject} onChange={e=>setForm(f=>({...f,subject:e.target.value}))}>
            {['History','Geography','Polity','Economy','Environment','Current Affairs','Optional','Essay','English','CSAT'].map(s=><option key={s}>{s}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Topic</div>
          <input className="form-input" value={form.topic} onChange={e=>setForm(f=>({...f,topic:e.target.value}))} placeholder="What did you study?"/>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Duration (minutes)</div>
          <input className="form-input" type="number" value={form.duration} onChange={e=>setForm(f=>({...f,duration:e.target.value}))} placeholder="Minutes"/>
        </div>
        <div style={{display:'flex',gap:'12px'}}>
          <button className="btn btn-primary" style={{flex:1}} onClick={()=>{if(form.topic&&form.duration)onSubmit(form);}}>Log</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function MockTestModal({onClose,onSubmit}) {
  const [form,setForm] = useState({testType:'prelims',testName:'',score:''});
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">📝 Log Mock Test</div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Test Type</div>
          <select className="form-select" value={form.testType} onChange={e=>setForm(f=>({...f,testType:e.target.value}))}>
            {['prelims','csat','mains','essay','optional'].map(t=><option key={t}>{t}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Test Name</div>
          <input className="form-input" value={form.testName} onChange={e=>setForm(f=>({...f,testName:e.target.value}))} placeholder="e.g., Prelims 2027 Mock 1"/>
        </div>
        <div style={{marginBottom:'16px'}}>
          <div className="form-label">Score</div>
          <input className="form-input" type="number" value={form.score} onChange={e=>setForm(f=>({...f,score:e.target.value}))} placeholder="Your score"/>
        </div>
        <div style={{display:'flex',gap:'12px'}}>
          <button className="btn btn-primary" style={{flex:1}} onClick={()=>{if(form.score)onSubmit(form);}}>Log</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
